document.addEventListener("DOMContentLoaded", function () {
  console.log("Free Shipping Bar Script Loaded!");

  // Check if the current page is the excluded one
  if (window.location.pathname === "/pages/agood-company-for-business") {
    console.log("Free Shipping Bar is disabled on this page.");
    return; // Exit the script without executing further
  }

  // Define the HTML structure for the free shipping bar
  const freeShippingBarHTML = `
  
    <div id="free-shipping-bar-right" class="free-shipping-text">
      You're ... away from FREE express shipping.
    </div>
  `;

  // Populate the bar
  const freeShippingBar = document.getElementById('free-shipping-bar');
  freeShippingBar.innerHTML = freeShippingBarHTML;

  // Apply additional styles
  freeShippingBar.style.display = "flex";
  freeShippingBar.style.justifyContent = "flex-end";
  freeShippingBar.style.alignItems = "center";
  freeShippingBar.style.color = "#fff";
  freeShippingBar.style.padding = "10px 20px";

  // Helper function to adjust padding dynamically
  function adjustBodyPadding() {
    const barHeight = freeShippingBar.offsetHeight;
    document.body.style.paddingTop = `${barHeight}px`;
  }

  // Initial adjustment
  adjustBodyPadding();

  // Recalculate padding on window resize (to handle mobile layouts)
  window.addEventListener("resize", adjustBodyPadding);

  const thresholdsByCountry = {
    EUR: { countries: ["AT", "BE", "FI", "FR", "NL", "LU", "DE", "IT", "ES", "PT", "GR", "IE", "CZ", "SK", "HU", "LT", "LV", "EE"], threshold: 60 },
    SEK: { countries: ["SE"], threshold: 600 },
    NOK: { countries: ["NO"], threshold: 700 },
    DKK: { countries: ["DK", "FO", "GL"], threshold: 450 },
    GBP: { countries: ["GB", "GI", "GG"], threshold: 50 },
    USD: { countries: ["US", "MX"], threshold: 60 },
    CAD: { countries: ["CA"], threshold: 90 },
    ALL: { countries: ["AL"], threshold: 7000 },
    AMD: { countries: ["AM"], threshold: 25000 },
    BYN: { countries: ["BY"], threshold: 200 },
    BAM: { countries: ["BA"], threshold: 120 },
    BGN: { countries: ["BG"], threshold: 120 },
    GEL: { countries: ["GE"], threshold: 180 },
    HUF: { countries: ["HU"], threshold: 24000 },
    ILS: { countries: ["IL"], threshold: 240 },
    MDL: { countries: ["MD"], threshold: 1200 },
    MKD: { countries: ["MK"], threshold: 3700 },
    PLN: { countries: ["PL"], threshold: 270 },
    RON: { countries: ["RO"], threshold: 300 },
    RSD: { countries: ["RS"], threshold: 7000 },
    CHF: { countries: ["LI", "CH"], threshold: 60 },
    UAH: { countries: ["UA"], threshold: 2500 },
    DEFAULT: { available: false, message: "Free Express Shipping is not available in your region." },
  };

  const freeShippingBarRight = document.getElementById('free-shipping-bar-right');

  // Helper function to determine the free shipping threshold
  function getThresholdForCountry(countryCode) {
    for (const [currency, data] of Object.entries(thresholdsByCountry)) {
      if (data.countries && data.countries.includes(countryCode)) {
        return { available: true, threshold: data.threshold, currency };
      }
    }
    // Return static message for unlisted countries
    return { available: false, message: thresholdsByCountry.DEFAULT.message };
  }

  // Immediately display placeholder
  const activeCurrency = Shopify.currency.active || "EUR";
  const activeCountry = window.localization?.country?.iso_code || "Country not found!";
  const { available, threshold, currency, message } = getThresholdForCountry(activeCountry);

  if (!available) {
    freeShippingBarRight.textContent = message; // Static message for unlisted countries
  } else {
    freeShippingBarRight.textContent = `You're ${currency} ${threshold.toFixed(2)} away from FREE express shipping.`;

    // Fetch and update cart data
    function updateFreeShippingBar() {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          const cartTotal = cart.total_price / 100; // Convert cents to base units
          const remainingAmount = threshold - cartTotal;

          if (remainingAmount > 0) {
            freeShippingBarRight.textContent = `You're ${currency} ${remainingAmount.toFixed(2)} away from FREE express shipping.`;
          } else {
            freeShippingBarRight.textContent = 'Congratulations! You qualify for free express shipping.';
          }
        })
        .catch(error => {
          console.error("Error fetching cart data:", error);
          freeShippingBarRight.textContent = 'Unable to calculate free shipping eligibility.';
        });
    }

    // Update the bar immediately and poll for changes
    updateFreeShippingBar();
    setInterval(updateFreeShippingBar, 3000); // Poll every 3 seconds
  }

  // Append the CSS for font size
  const style = document.createElement("style");
  style.textContent = `
    #free-shipping-bar {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      background-color: #e01217;
      z-index: 9999;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #fff;
      padding: 10px 20px;
      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
    }

    #free-shipping-bar a {
      font-size: 14px;
      color: #fff;
      text-decoration: none;
    }

    #free-shipping-bar a:hover {
      color: #ddd;
    }

    #free-shipping-bar-left,
    #free-shipping-bar-right {
      font-size: 14px;
    }

    @media (max-width: 768px) {
      #free-shipping-bar {
        flex-direction: column;
        text-align: center;
        padding: 0 !important;
      }

      #free-shipping-bar a,
      #free-shipping-bar-left,
      #free-shipping-bar-right {
        font-size: 12px;
      }

      #free-shipping-bar-left {
        background-color: #e01217;
        width: 100%;
        padding: 10px;
        margin-bottom: 5px;
      }

      #free-shipping-bar-right {
        background-color: black;
        width: 100%;
        padding: 10px;
      }
    }
  `;
  document.head.appendChild(style);
});
